import ModalService from "../modals/ModalService";
import ErrorModal from "../modals/ErrorModal";
import SuccessModal from "../modals/SuccessModal";
import LoadingModal from "../modals/LoadingModal";

export const addModal = (props) => {
  switch (props.modal) {
    case "SuccessModal":
      ModalService.open(SuccessModal, { linkTo: props.linkTo });
      break;
    case "LoadingModal":
      ModalService.open(LoadingModal);
      break;
    case "ErrorModal":
      ModalService.open(ErrorModal, { linkTo: props.linkTo });
      break;
    case "close":
      ModalService.open(LoadingModal.close);
      break;
    default:
    // code block
  }
};
